export default __webpack_public_path__ + "static/media/food.55d891cf.png";